import React from 'react';

//Images
import regular from "../../../images/variations/finish-regular.jpg";
import tumbled from "../../../images/variations/finish-tumbled.jpg";
import porcelain from "../../../images/variations/finish-porcelain.jpg";

const Finishes = () => {
  return (
    <div className="row justify-content-center panel-finishes">
      <div className="col-12 text-uppercase text-center mt-5 mb-5">
        <h3 className="text-blue">Types of Finishes</h3>
      </div>
      <div className="col-10 col-md-4 text-center">
        <img src={regular} alt="Regular Finish"/>
        <p className="mt-3 text-uppercase text-center">Regular Finish</p>
      </div>
      <div className="col-10 col-md-4 text-center">
        <img src={tumbled} alt="Tumbled Finish"/>
        <p className="mt-3 text-uppercase text-center">Tumbled Finish</p>
      </div>
      <div className="col-10 col-md-4 text-center">
        <img src={porcelain} alt="Porcelain Finish"/>
        <p className="mt-3 text-uppercase text-center">Porcelain Finish</p>
      </div>
    </div>
  )
}

export default Finishes
